import WithAuth from "@components/auth/with-auth"
import Breadcrumbs from "@components/layout/breadcrumbs"
import { DrawerProvider } from "@components/layout/drawer-provider"
import { ModalProvider } from "@components/layout/modal-provider"
import { Sidebar } from "@components/layout/sidebar"
import { TopNavigation } from "@components/layout/top-nav"
import useTranslator from "@hooks/use-translator"
import { useAuth } from "@stores/auth-store"
import { cn } from "@pma/utils/helpers"
import { ReactNode, useEffect, useState } from "react"
import { ProjectProvider } from "@pma/contexts/ProjectContext"
import { useModal } from "@pma/stores/modal-store"
import { Button } from "@pma/components/common/button"
import { BrainIcon } from "lucide-react"
import { Tooltip, TooltipContent, TooltipTrigger } from "@pma/components/common/tooltip"
import { useWarnings } from "@pma/contexts/WarningsContext"
import WarningAlert from "./WarningAlert"

interface Props {
  children: ReactNode
}
const DashboardLayout = ({ children }: Props) => {
  const { warnings } = useWarnings()
  const [isOpen, setIsOpen] = useState(true)
  const modal = useModal()

  const { locale, translate } = useTranslator()
  const { authConfig } = useAuth()

  const orgId = authConfig?.last_organization_id

  const isHebrew = locale === "he"

  useEffect(() => {}, [orgId])

  return (
    <WithAuth>
      <ProjectProvider>
        <main className={cn("relative", isHebrew ? "rtl" : "ltr")}>
          <Sidebar setIsOpen={setIsOpen} isOpen={isOpen} />
          <TopNavigation />
          <div
            className={`sticky top-[71px] z-10 my-3 flex items-center justify-between space-x-2 bg-white/90 px-4 py-2 ${
              isOpen
                ? `${isHebrew ? "lg:mr-52" : "lg:ml-52"}`
                : `${isHebrew ? "lg:mr-14" : "lg:ml-14"}`
            }`}
          >
            <Breadcrumbs />
          </div>

          <WarningAlert isOpen={isOpen} />

          <div
            className={`mt-[70px] h-auto px-4 pt-2 transition-[margin] ${
              isOpen
                ? `${isHebrew ? "lg:mr-52" : "lg:ml-52"}`
                : `${isHebrew ? "lg:mr-14" : "lg:ml-14"}`
            }`}
          >
            {children}
            <ModalProvider />
            <DrawerProvider />

            {/* Open AI assistant */}
            <Tooltip>
              <TooltipTrigger className={cn("fixed top-[95vh]", isHebrew ? "left-4" : "right-4")}>
                <Button
                  variant='default'
                  onClick={() => {
                    modal.onOpen()
                    modal.setContext("ai")
                  }}
                  className={cn("flex h-10 w-10 items-center justify-center rounded-full p-0")}
                >
                  <BrainIcon size={20} />
                </Button>
              </TooltipTrigger>
              <TooltipContent alignOffset={20}>
                <div className='flex items-center gap-1'>
                  <h4>{translate("Ask Ai")}</h4>
                </div>
              </TooltipContent>
            </Tooltip>
          </div>
        </main>
      </ProjectProvider>
    </WithAuth>
  )
}

export default DashboardLayout
